import { render, staticRenderFns } from "./permissions-toggle.vue?vue&type=template&id=6ab4f7dc&scoped=true&"
import script from "./permissions-toggle.vue?vue&type=script&lang=js&"
export * from "./permissions-toggle.vue?vue&type=script&lang=js&"
import style0 from "./permissions-toggle.vue?vue&type=style&index=0&id=6ab4f7dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab4f7dc",
  null
  
)

export default component.exports